var t=["width","height","top","right","bottom","left"],n=function(n,e){return void 0===n&&(n={}),void 0===e&&(e={}),t.some(function(t){return n[t]!==e[t]})};export default function(t,e){var o,i,r=function(){var u=t.getBoundingClientRect();n(u,o)&&e(o=u),i=requestAnimationFrame(r)};return{observe:r,unobserve:function(){cancelAnimationFrame(i)}}};
//# sourceMappingURL=index.m.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@reach/observe-rect/dist/index.m.js
// module id = 577
// module chunks = 3